import React, { useEffect, useState, useRef } from "react";
import { Divider } from 'primereact/divider';
import { Chart } from 'primereact/chart';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import visitorIcon from "../../../assets/Icon-Images/icon-visitors.png";
import chatIcon from "../../../assets/Icon-Images/icon-chats.png";
import meaningfulIcon from "../../../assets/Icon-Images/icon-meaningful.jpg";
import leadsIcon from "../../../assets/Icon-Images/icon-leads.jpg";
import firstRTIcon from "../../../assets/Icon-Images/icon-frt.jpg";
import avgRTIcon from "../../../assets/Icon-Images/icon-art.jpg";
import avgChat from "../../../assets/Icon-Images/icon-acd.jpg";
import sendingTime from "../../../assets/Icon-Images/icon-acst.jpg";
import performane from "../../../assets/Icon-Images/icon-how-we-fared.jpg";
import happyIcon from "../../../assets/Icon-Images/icon-client-happy.jpg";
import unhappyIcon from "../../../assets/Icon-Images/icon-client-unhappy.jpg";
import update from "../../../assets/Icon-Images/icon-updates.jpg";
import coverage from "../../../assets/Icon-Images/icon-qc-coverage.jpg";
import systeminfoIcon from "../../../assets/Icon-Images/icon-system-info.jpg";
import inquiredIcon from "../../../assets/Icon-Images/icon-most-inquired-vehicles.jpg";
import distributionIcon from "../../../assets/Icon-Images/icon-distribution.jpg";
import trafficTrendsIcon from "../../../assets/Icon-Images/icon-traffic-indicators.jpg";
import sourceIcon from "../../../assets/Icon-Images/icon-top-5-traffic.jpg";
import chatLeadsIcon from "../../../assets/Icon-Images/icon-most-inquired-vehicles.jpg";
import apptIcon from "../../../assets/Icon-Images/icon-sales-appt.jpg";
import trandeinIcon from "../../../assets/Icon-Images/icon-trade-in.jpg";
import noteImage from "../../../assets/Icon-Images/notes-bg.png";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import 'jspdf-autotable'
import { Ripple } from "primereact/ripple";
import { LoginResponse } from "../../../models/index";
import { wglcsApiService } from "../../../services/WglcsApiService";
import _ from "lodash";
import moment from "moment";
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { ProgressSpinner } from "primereact/progressspinner";
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import '../menu.css'
import { Skeleton } from "primereact/skeleton";
import EventEmitter, { Events } from "../../../services/eventemitter";
import { DetectEnvironment } from "../../../EnvironmentSettings";
import { utils } from "../../../utils/index";
import { t } from "i18next";

const MonthlyAccountSummary = () => {
    var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse

    const fDate = new Date();
    fDate.setDate(1); // Set to the first day of the month
    const [fromDate, setFromDate] = useState<any>(fDate);

    const [desktopchatAvg, setDesktopchatAvg] = useState("")
    const [mblchatAvg, setMblchatAvg] = useState("")
    const [desktopvisitorAvg, setDesktopVisitorAvg] = useState("")
    const [mblvisitorAvg, setMblvisitorAvg] = useState("")
    const [chatAvg, setChatAvg] = useState("")
    const [desktopmfchatAvg, setDesktopmfchatAvg] = useState("")
    const [mblmfchatAvg, setMblmfchatAvg] = useState("")
    const [MFChatAvg, setMFChatAvg] = useState("")
    const [desktopmfchatContactAvg, setDesktopmfchatContactAvg] = useState("")
    const [mblmfchatContactAvg, setMblmfchatContactAvg] = useState("")
    const [MFchatContactAvg, setMFchatContactAvg] = useState("")
    const [firstResponseTime, setFirstResponseTime] = useState("")
    const [avgResponseTime, setAvgResponseTime] = useState("")
    const [avgsendingTime, setAvgsendingTime] = useState("")
    const [data, setData] = useState<any>(null)
    const [hidebutton, setHideButton] = useState(true)

    const [toDate, setToDate] = useState<any>(new Date());
    const [selectedCompanyName, setSelectedCompanyName] = useState<any>(null);
    const [selectedWebsite, setSelectedWebsite] = useState<any>(null);
    const [selectedTimeZone, setSelectedTimeZone] = useState<any>(null);
    const [loadingCompanies, setLoadingCompanies] = useState(true)
    const [CompanyArray, setCompanyArray] = useState([])
    const [WebsiteArray, setWebsiteArray] = useState<any>([])
    const [TimeArray, setTimeArray] = useState<any>([])
    const [loading, setLoading] = useState(false)
    const [timeloading, setTimeLoading] = useState(true)
    const [defaultTime, setDefaultTime] = useState<any>(null);
    const timeZoneRef = useRef<any>(null);
    const CompanyRef = useRef<any>(null);
    const [exportloading, setExportLoading] = useState(false)
    const skeletonLength = [
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
        { name: "" },
    ]
    const [refreshState, setRefreshState] = useState<any>(new Date())
    useEffect(() => {
        EventEmitter.on(Events.changelayOutMode, toggleDarkMode);
        EventEmitter.on(Events.forceFullyChangeLanguage, forceFullyChangeLanguage);
    }, [])
    const toggleDarkMode = () => {
        setRefreshState(new Date()?.getTime())
    }
    const forceFullyChangeLanguage = () => {
        setRefreshState(new Date()?.getTime())
    }
    useEffect(() => {
        ApiCalls()
    }, [])

    useEffect(() => {
        timeZone()
    }, [selectedWebsite])

    const ApiCalls = async () => {
        loadCompanies()
        timeZone()
    };
    const loadCompanies = async () => {
        let apiResponse = await wglcsApiService.getallCompaniesbyEmployeeCompanyid(userData?.userLoginData?.empCompId.toString());
        var arr = _.orderBy(apiResponse?.data?.data, ["companyName"], ["asc"]);
        setCompanyArray(arr as any)
        setLoadingCompanies(false)
    };
    const timeZone = async () => {
        let apiResponse = await wglcsApiService.GetAllReportingTimeZones();
        if (apiResponse) {
            setTimeLoading(false)
            if (selectedWebsite != null) {
                var data = apiResponse.data.filter(m => m.standardName == selectedWebsite.timeZone)
                if (data.length > 0) {
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                } else {
                    var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                    setTimeArray(apiResponse.data)
                    setSelectedTimeZone(data[0])
                    setDefaultTime(data[0])
                }
            }
            else {
                var data = apiResponse.data.filter(m => m.standardName === "Pakistan Standard Time")
                setTimeArray(apiResponse.data)
                setSelectedTimeZone(data[0])
                setDefaultTime(data[0])
            }
        }
    }
    const onTimeChange = (e) => {
        setSelectedTimeZone(e.value);
    }
    const commonRequestData = () => {
        return {
            fromDate: moment(fromDate).format("YYYY-MM-DD"),
            toDate: moment(toDate).format("YYYY-MM-DD"),
            companyId: selectedCompanyName?.companyId,
            websiteId: selectedWebsite?.websiteId,
            timeZone: selectedTimeZone?.standardName,
            timeType: "",
            agentId: 0,
            chatCountBy: "",
            timeFrom: "",
            timeTo: "",
            region: "",
        };
    };
    const fromData = (e) => {
        var fDate = moment(e.value).format("YYYY-MM-DD");
        setFromDate(e.value)
    }
    const toData = (e) => {
        var tDate = moment(e.value).format("YYYY-MM-DD");
        setToDate(tDate)
    }
    const onCompanyChange = (e) => {
        setSelectedCompanyName(e.value);
        loadWebsites(e.value.companyId);
    }
    const onWebsiteChange = (e) => {
        setSelectedWebsite(e.value);
        timeZoneRef?.current.resetFilter();
    }
    const loadWebsites = async (id) => {
        let response = await wglcsApiService.getwebsitebycompanyId(id);
        var data = response.data.data.filter(m => m.status === true)
        setWebsiteArray(data)
        setSelectedWebsite(data[0])
    };
    const CompanyOptionTemplate = (option) => {
        if (loadingCompanies) {
            return (
                <div style={{ margin: "2px" }} >
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.companyName}</div>
                </div>
            );
        }
    };
    const MASR = async () => {
        var result = await wglcsApiService.MonthlyAccountSummaryReport(commonRequestData())
        if (result.data.data) {
            setData(result.data.data)
            setLoading(false)
        }
    }
    const submit = () => {
        if (!selectedCompanyName) {
            EventEmitter.emit(Events.DisplayApiErrorResponse, t('toast.Company-validation'))
            return;
        }
        else {
            setLoading(true)
            setData(null)
            MASR()
            setHideButton(false)
        }
    }
    function base64ToBlob(base64String, contentType) {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    function downloadBlob(blob, fileName) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }
    async function captureSectionToBlob(sectionId) {
        const section = document.getElementById(sectionId);
        const canvas = await html2canvas(section as any);
        const imgData = canvas.toDataURL('image/png');
        return base64ToBlob(imgData.split(',')[1], 'image/png');
    }
    const captureScreen = async () => {
        const sectionIds = ['section1', 'section2', 'section3', 'section4'];
        var blobs: any = [];

        for (const sectionId of sectionIds) {
            const blob = await captureSectionToBlob(sectionId);
            blobs.push(blob);
        }

        // Combine blobs or handle them as needed (e.g., create a PDF)
        const combinedBlob = new Blob(blobs, { type: 'image/png' });

        // Download the combined blob
        downloadBlob(combinedBlob, 'combined-image.png');
    };


    const ExportPDF = async () => {
        setExportLoading(true)
        const element = document.getElementById('reportContent');
        if (element) {
            const pdf = new jsPDF();
            const sectionIds = ['section1', 'section2', 'section3', 'section4'];

            const logoWidth = 100;
            const logoHeight = 36;
            const logoY = 1;
            const logoX = 90;
            const pdfWidth = pdf.internal.pageSize.getWidth();
            // const centerX = (pdfWidth - logoWidth) / 2;

            for (let i = 0; i < sectionIds.length; i++) {
                const sectionId = sectionIds[i];
                const section = document.getElementById(sectionId);

                if (i > 0) {
                    pdf.addPage();  // Add a new page for each section (except the first one)
                }

                // Draw the section content
                if (section) {
                    const canvas = await html2canvas(section);
                    const imgData = canvas.toDataURL('image/png');
                    pdf.addImage(imgData, 'PNG', 0, 10, pdf.internal.pageSize.getWidth(), pdf.internal.pageSize.getHeight());

                    if (sectionId == 'section1') {
                        const imageElement = document.getElementById('logoImage');
                        const imgDataUrl = imageElement?.getAttribute('src') || ''; // Get the image source URL

                        // Draw the logo on the first page
                        const canvasLogo = document.createElement('canvas');
                        const ctxLogo = canvasLogo.getContext('2d');

                        if (ctxLogo) {
                            const imgLogo = new Image();
                            imgLogo.src = imgDataUrl;
                            await new Promise(resolve => {
                                imgLogo.onload = () => {
                                    ctxLogo.drawImage(imgLogo, 0, 0, logoWidth, logoHeight);
                                    resolve(null);
                                };
                            });
                            const logoDataUrl = canvasLogo.toDataURL('image/png');
                            pdf.addImage(logoDataUrl, 'PNG', logoX, logoY, logoWidth, logoHeight);
                        }
                    }
                }
            }
            pdf.save('Monthly Account Summary Report.pdf');
        }
        setExportLoading(false)
    };

    const filteredData = data?.monthlyAccountSummaryTopChatAndTraffic.filter(f => f.type == 0)
    const newArray = filteredData?.map(item => ({ name: item.referrer, y: item.totalVisitor }))
    const filteredData2 = data?.monthlyAccountSummaryTopChatAndTraffic.filter(f => f.type == 1)
    const newArray2 = filteredData2?.map(item => ({ name: item.referrer, y: item.totalVisitor }))


    useEffect(() => {
        mblvisitor_Avg()
        desktopvisitor_Avg()
        mblchat_Avg()
        desktopchat_Avg()
        chat_Avg()
        mblmfchat_Avg()
        desktopmfchat_Avg()
        Mfchat_Avg()
        mblmfchatContact_Avg()
        desktopmfchatContact_Avg()
        MfchatContact_Avg()
        totalfirstresponse()
        totalavgresponse()
        avg_sendingTime()
    }, [data])

    const mblvisitor_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblvisitor
        var total = data?.monthlyAccountSummaryStats[0]?.mblvisitor + data?.monthlyAccountSummaryStats[0]?.visitor
        if (value == 0 && total == 0) {
            setMblvisitorAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setMblvisitorAvg(sum.toFixed(2) + "%")
        }
    };
    const desktopvisitor_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.visitor
        var total = data?.monthlyAccountSummaryStats[0]?.mblvisitor + data?.monthlyAccountSummaryStats[0]?.visitor
        if (value == 0 && total == 0) {
            setDesktopVisitorAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setDesktopVisitorAvg(sum.toFixed(2) + "%")
        }
    };
    const mblchat_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblchat
        var total = data?.monthlyAccountSummaryStats[0]?.mblvisitor
        if (value == 0 && total == 0) {
            setMblchatAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setMblchatAvg(sum.toFixed(2) + "%")
        }
    };
    const desktopchat_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.chat
        var total = data?.monthlyAccountSummaryStats[0]?.visitor
        if (value == 0 && total == 0) {
            setDesktopchatAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setDesktopchatAvg(sum.toFixed(2) + "%")
        }
    };
    const chat_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblchat + data?.monthlyAccountSummaryStats[0]?.chat
        var total = data?.monthlyAccountSummaryStats[0]?.mblvisitor + data?.monthlyAccountSummaryStats[0]?.visitor
        if (value == 0 && total == 0) {
            setChatAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setChatAvg(sum.toFixed(2) + "%")
        }
    };
    const mblmfchat_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblbillable
        var total = data?.monthlyAccountSummaryStats[0]?.mblchat
        if (value == 0 && total == 0) {
            setMblmfchatAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setMblmfchatAvg(sum.toFixed(2) + "%")
        }
    };
    const desktopmfchat_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.billable
        var total = data?.monthlyAccountSummaryStats[0]?.chat
        if (value == 0 && total == 0) {
            setDesktopmfchatAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setDesktopmfchatAvg(sum.toFixed(2) + "%")
        }
    };
    const Mfchat_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblbillable + data?.monthlyAccountSummaryStats[0]?.billable
        var total = data?.monthlyAccountSummaryStats[0]?.mblchat + data?.monthlyAccountSummaryStats[0]?.chat
        if (value == 0 && total == 0) {
            setMFChatAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setMFChatAvg(sum.toFixed(2) + "%")
        }
    };
    const mblmfchatContact_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblLeadsChat
        var total = data?.monthlyAccountSummaryStats[0]?.mblbillable
        if (value == 0 && total == 0) {
            setMblmfchatContactAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setMblmfchatContactAvg(sum.toFixed(2) + "%")
        }
    };
    const desktopmfchatContact_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.leadsChat
        var total = data?.monthlyAccountSummaryStats[0]?.billable
        if (value == 0 && total == 0) {
            setDesktopmfchatContactAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setDesktopmfchatContactAvg(sum.toFixed(2) + "%")
        }
    };
    const MfchatContact_Avg = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblLeadsChat + data?.monthlyAccountSummaryStats[0]?.leadsChat
        var total = data?.monthlyAccountSummaryStats[0]?.mblbillable + data?.monthlyAccountSummaryStats[0]?.billable
        if (value == 0 && total == 0) {
            setMFchatContactAvg("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total * 100
            setMFchatContactAvg(sum.toFixed(2) + "%")
        }
    };
    const totalfirstresponse = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblAvgFirstResponse + data?.monthlyAccountSummaryStats[0]?.avgFirstResponse
        var total = 2
        if (value == 0 && total == 0) {
            setFirstResponseTime("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total
            setFirstResponseTime(sum.toFixed(1) + "s")
        }
    };
    const totalavgresponse = () => {
        var value = data?.monthlyAccountSummaryStats[0]?.mblAvgChatResponse + data?.monthlyAccountSummaryStats[0]?.avgChatResponse
        var total = 2
        if (value == 0 && total == 0) {
            setAvgResponseTime("0.00" + "%")
        } else {
            let sum = 0;
            sum = value / total
            setAvgResponseTime(sum.toFixed(1) + "s")
        }
    };
    const avg_sendingTime = () => {
        var SendingTimeMint = data?.monthlyAccountSummaryThumbsUp[0]?.avgChatSendingTimeMint
        var SendingTimeSec = data?.monthlyAccountSummaryThumbsUp[0]?.avgChatSendingTimeSec
        var value = data?.monthlyAccountSummaryThumbsUp[0]?.avgChatSendingTimeMint + "m" + data?.monthlyAccountSummaryThumbsUp[0].avgChatSendingTimeSec + "s"
        if (SendingTimeMint == null && SendingTimeSec == null) {
            setAvgsendingTime("0m0s")
        } else {
            setAvgsendingTime(value)
        }
    };
    const basicData = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        xAxis: {
            categories: data?.monthlyAccountSummaryCityCountry?.map(m => m.country),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: ''
            },
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        tooltip: {
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            line: {
                color: '#4e86c7' // Set line color here
            }
        },
        series: [
            { name: "Country Wise Data", data: data?.monthlyAccountSummaryCityCountry?.map(m => m.chats) }
        ], legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    };

    const weekendchats = data?.monthlyAccountSummaryWeekdaysAndWeekends?.filter(f => f.type == 1).map(m => m.chats)
    const weekendhous = data?.monthlyAccountSummaryWeekdaysAndWeekends?.filter(f => f.type == 1).map(m => m.hour)
    const weekchats = data?.monthlyAccountSummaryWeekdaysAndWeekends?.filter(f => f.type == 0).map(m => m.chats)
    const weekhous = data?.monthlyAccountSummaryWeekdaysAndWeekends?.filter(f => f.type == 0).map(m => m.hour)
    const hasWeekendData = weekendchats && weekendchats.length > 0;
    const hasWeekData = weekchats && weekchats.length > 0

    const WeekOptions = {
        chart: {
            type: 'line',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.HourWise-ChatFrequency-Weekdays'),
            style: {
                fontSize: '14px', // Set the desired font size here
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: weekhous,
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: ''
            },
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        tooltip: {
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            line: {
                color: '#4e86c7' // Set line color here
            }
        },
        series: [
            { name: "", data: weekchats }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const WeekendOptions = {
        chart: {
            type: 'line',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: t('GraphReports-label.HourWise-ChatFrequency-Weekends'),
            style: {
                fontSize: '14px', // Set the desired font size here
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        xAxis: {
            categories: weekendhous,
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: ''
            },
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        tooltip: {
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            line: {
                color: '#4e86c7' // Set line color here
            }
        },
        series: [
            { name: "", data: weekendchats }
        ],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const Options1 = {
        chart: {
            type: 'pie',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0',
            height: 330
        },
        title: {
            text: t('GraphReports-label.TOP5-TRAFFICSOURCE'),
            style: {
                fontSize: '12px', // Set the desired font size here
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        tooltip: {
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<span style="font-size: 1em"><b>{point.name}</b></span><br>' +
                        '<span style="opacity: 0.6">{point.percentage:.1f}% </span>' +
                        '<span style="opacity: 0.6">({point.y})</span>',
                    connectorColor: 'rgba(128,128,128,0.5)'
                }
            }
        },
        series: [{
            data: newArray
        }],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const Options2 = {
        chart: {
            type: 'pie',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0',
            height: 350
        },
        title: {
            text: t('GraphReports-label.TOP5-CHATSOURCE'),
            style: {
                fontSize: '12px', // Set the desired font size here
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        },
        tooltip: {
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<span style="font-size: 1em"><b>{point.name}</b></span><br>' +
                        '<span style="opacity: 0.6">{point.percentage:.1f} %</span>' +
                        '<span style="opacity: 0.6">({point.y})</span>',
                    connectorColor: 'rgba(128,128,128,0.5)'
                }
            }
        },
        series: [{
            data: newArray2
        }],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }

    var monthlyAccountSummaryChat = data?.monthlyAccountSummaryChatDistributions?.map(item => ({ name: item.departmentName, y: item.chats, drilldown: item.departmentName }))
    const ChatDistributionData = monthlyAccountSummaryChat && monthlyAccountSummaryChat.length > 0
    const ChatDistributions = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0',
        },
        title: {
            text: ''
        },
        xAxis: {
            type: 'category',
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: ''
            },
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        tooltip: {
            // valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                },
                color: '#4e86c7', // Set the color for all columns in the series
            },
            column: {
                pointPadding: 0.25,
                borderWidth: 0,
            }
        },
        series: [{
            name: t("GraphReports-label.Chat-Distribution"),
            data: monthlyAccountSummaryChat,
        }],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }

    const ChatLead_Data1 = {
        chart: {
            type: 'column',
            backgroundColor: utils.isDarkMode() ? "#000000" : '#f0f0f0'
        },
        title: {
            text: ""
        },
        xAxis: {
            categories: data?.monthlyAccountSummaryLastThreeMonths?.map(m => m.month),
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        yAxis: {
            title: {
                text: ''
            },
            color: utils.isDarkMode() ? "#FFFFFF" : "",
            labels: {
                style: {
                    color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
                }
            },
            lineColor: utils.isDarkMode() ? "#FFFFFF" : "#000000"
        },
        tooltip: {
            // valueSuffix: ' (1000 MT)',
            style: {
                color: utils.isDarkMode() ? 'white' : "black", // Tooltip text color
            },
            backgroundColor: utils.isDarkMode() ? 'black' : "white", // Background color of the tooltip popup
            borderWidth: 0, // Border width of the tooltip popup
            borderRadius: 5, // Border radius of the tooltip popup
        },
        plotOptions: {
            series: {
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    format: '{point.y}'
                }
            },
            column: {
                pointPadding: 0.35,
                borderWidth: 0
            }
        },
        series: [{
            name: t('ReportComponent.Chats'),
            data: data?.monthlyAccountSummaryLastThreeMonths?.map(m => ({ y: m.chats, color: '#4e86c7' })),
            color: '#4e86c7', marker: {
                symbol: 'circle', // Set symbol type
                fillColor: '#4e86c7' // Set symbol color
            }
        },
        {
            name: t('ChatTranscriptComponent.Billable'),
            data: data?.monthlyAccountSummaryLastThreeMonths?.map(m => ({ y: m.billable, color: '#99A3A4' })),
            color: '#99A3A4',
            marker: {
                symbol: 'circle', // Set symbol type
                fillColor: '#99A3A4' // Set symbol color
            }
        },
        {
            name: t('viewStatistics.Billable Ratio'),
            data: data?.monthlyAccountSummaryLastThreeMonths?.map(m => ({ y: m.billableRatio, color: '#76CA31' })),
            color: '#76CA31',
            marker: {
                symbol: 'circle', // Set symbol type
                fillColor: '#76CA31' // Set symbol color
            }
        }],
        legend: {
            itemStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            },
            itemHoverStyle: {
                color: utils.isDarkMode() ? "#FFFFFF" : "#000000"
            }
        }
    }
    const TimeTemplate = (option) => {
        if (timeloading) {
            return (
                <div style={{ margin: "2px" }}>
                    <Skeleton ></Skeleton>
                </div>
            );
        }
        if (option) {
            return (
                <div className="country-item">
                    <div>{option.displayName}</div>
                </div>
            );
        }
    };
    const renderLoader = () => {
        return (
                <ProgressSpinner strokeWidth="3" fill="#EEEEEE" animationDuration=".5s" />
          
        );
    }
    return (
        <div className="wgReoprts-container">
            <div className="row p-2">
                <img id="logoImage" style={{ display: "none" }} src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_LOGO} alt="" />
                <div className="wgreport-tab viewreport-box">
                    <div className="row view-wgreport ">
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('smtp-DataTable.Company-Name')}</label>
                            <div className="spinner-box">
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="companyName"
                                value={selectedCompanyName}
                                options={CompanyArray}
                                onChange={onCompanyChange}
                                optionLabel="companyName"
                                placeholder={!loadingCompanies ? t('fieldsPlaceholder.selectCompany') : selectedCompanyName}
                            // itemTemplate={CompanyOptionTemplate}
                            // ref={CompanyRef}
                            />
                            {loadingCompanies && renderLoader()}
                            </div>
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="basic">{t('MonitoringPanel 6erComponent.Website-Name')}</label>
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="domainName"
                                value={selectedWebsite}
                                options={WebsiteArray}
                                onChange={onWebsiteChange}
                                optionLabel="domainName"
                                placeholder={t('ReportComponent.Select Website')} />
                        </div>
                        <div className="col-md-3 col-lg-3 py-1 wgreport" >
                            <label className="wgreport-label" htmlFor="firstname6">{t('ChatTranscriptComponent.From Date')}</label>
                            <Calendar showIcon value={fromDate} onChange={(e) => fromData(e)}
                                minDate={new Date(new Date().getFullYear(), new Date().getMonth() - 5, 1)}
                                maxDate={new Date()}
                            />
                        </div>

                        <div className="col-md-3 col-lg-3 py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ChatTranscriptComponent.To Date')}</label>
                            <Calendar id="abc" showIcon value={toDate} onChange={(e) => toData(e)}
                                maxDate={new Date()}
                                minDate={new Date(fromDate.getFullYear(), fromDate.getMonth(), 1)}
                            />
                        </div>
                        <div className="col-md-3 col-lg-3  py-1 wgreport">
                            <label className="wgreport-label" htmlFor="basic">{t('ManagePoc-DataTable.Time-Zone')}</label>
                            <div className="spinner-box">
                            
                            <Dropdown className="form-control"
                                filter
                                showFilterClear
                                filterBy="displayName"
                                value={selectedTimeZone}
                                options={TimeArray}
                                onChange={onTimeChange}
                                optionLabel="displayName"
                                // itemTemplate={TimeTemplate}
                                placeholder={!timeloading ? t('ManagePoc-DataTable.Select-TimeZone') : selectedTimeZone}
                            // ref={timeZoneRef}
                            />
                            {timeloading && renderLoader()}
                            </div>
                        </div>
                        <div className="col-md-9 py-1 text-right text-md-left">
                            {hidebutton == false ? <>   <button title={t('wg-buttons.Export-PDF')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => ExportPDF()}> <Ripple />{exportloading ?
                                <ProgressSpinner
                                    style={{ width: "25px", bottom: "10px" }}
                                    strokeWidth="3"
                                    fill="#EEEEEE"
                                    animationDuration=".5s"
                                /> : t('wg-buttons.Export-PDF')}</button>
                            </> : ""}
                            <button title={t('wg-buttons.View-Report')} className="btn-width wgreport-btn wgbtn p-ripple" onClick={() => submit()}> <Ripple />{t('wg-buttons.View-Report')}</button>
                        </div>
                    </div>
                </div>
            </div>
            {loading == true ?
                <ProgressSpinner
                    style={{ width: "50px", poition: "relative", top: "10rem", left: "30rem" }}
                    strokeWidth="3"
                    fill="#EEEEEE"
                    animationDuration=".5s"
                />
                : ""}
            <div className="card" id="reportContent">
                {data != null && loading == false ? <>
                    <div id="section1">
                        <h4 className="wgreport_heading">{t('DashboardReports.MonthlyAccountSummary')}</h4>
                        <div className="img-div">
                            <img className="wgreport-icon" src={visitorIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.VISITORS')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblvisitor}
                                    {data?.monthlyAccountSummaryStats[0]?.mblvisitor > data?.monthlyAccountSummaryStats[0]?.preMblvisitor ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>}
                                </span>
                                <span className="wgreport-MAS">{mblvisitorAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblvisitor + data?.monthlyAccountSummaryStats[0]?.visitor}
                                    {data?.monthlyAccountSummaryStats[0]?.mblvisitor + data?.monthlyAccountSummaryStats[0]?.visitor > data?.monthlyAccountSummaryStats[0]?.preMblvisitor + data?.monthlyAccountSummaryStats[0]?.previsitor ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>}
                                </span>
                                <label className="wgreport-MASlabel" style={{ marginTop: "25px" }}>{t('DashboardReport-dataTable.Total')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.visitor}
                                    {data?.monthlyAccountSummaryStats[0]?.visitor > data?.monthlyAccountSummaryStats[0]?.previsitor ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>}
                                </span>
                                <span className="wgreport-MAS">{desktopvisitorAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={chatIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.CHATS')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblchat}
                                    {data?.monthlyAccountSummaryStats[0]?.mblchat > data?.monthlyAccountSummaryStats[0]?.preMblchat ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>}
                                </span>
                                <span className="wgreport-MAS">{mblchatAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblchat + data?.monthlyAccountSummaryStats[0]?.chat}
                                    {data?.monthlyAccountSummaryStats[0]?.mblchat + data?.monthlyAccountSummaryStats[0]?.chat >
                                        data?.monthlyAccountSummaryStats[0]?.preMblchat + data?.monthlyAccountSummaryStats[0]?.prechat ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>
                                    }
                                </span>
                                <span className="wgreport-MAS">{chatAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.OUT-TOTALTRAFFIC')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.chat}
                                    {data?.monthlyAccountSummaryStats[0]?.chat > data?.monthlyAccountSummaryStats[0]?.prechat ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>}
                                </span>
                                <span className="wgreport-MAS">{desktopchatAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={meaningfulIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.MEANINGFULCHATS')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblbillable}
                                    {data?.monthlyAccountSummaryStats[0]?.mblbillable > data?.monthlyAccountSummaryStats[0]?.preMblbillable ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>
                                    }
                                </span>
                                <span className="wgreport-MAS">{mblmfchatAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblbillable + data?.monthlyAccountSummaryStats[0]?.billable}
                                    {data?.monthlyAccountSummaryStats[0]?.mblbillable + data?.monthlyAccountSummaryStats[0]?.billable >
                                        data?.monthlyAccountSummaryStats[0]?.preMblbillable + data?.monthlyAccountSummaryStats[0]?.prebillable
                                        ? <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>}
                                </span>
                                <span className="wgreport-MAS">{MFChatAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.OUT-TOTALCHATS')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.billable}
                                    {data?.monthlyAccountSummaryStats[0]?.billable > data?.monthlyAccountSummaryStats[0]?.prebillable ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>
                                    }
                                </span>
                                <span className="wgreport-MAS">{desktopmfchatAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={leadsIcon} />
                        </div>
                        <h6 className="wgreport_heading" >{t('DashboardReport-dataTable.MEANINGFULCHATS-WITHCONTACTS')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblLeadsChat}
                                    {data?.monthlyAccountSummaryStats[0]?.mblLeadsChat > data?.monthlyAccountSummaryStats[0]?.preMblLeadsChat ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>
                                    }
                                </span>
                                <span className="wgreport-MAS">{mblmfchatContactAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblLeadsChat + data?.monthlyAccountSummaryStats[0]?.leadsChat}
                                    {data?.monthlyAccountSummaryStats[0]?.mblLeadsChat + data?.monthlyAccountSummaryStats[0]?.leadsChat >
                                        data?.monthlyAccountSummaryStats[0]?.preMblLeadsChat + data?.monthlyAccountSummaryStats[0]?.preLeadsChat ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>
                                    }
                                </span>
                                <span className="wgreport-MAS">{MFchatContactAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.OUT-MEANINGFULCHATS')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.leadsChat}
                                    {data?.monthlyAccountSummaryStats[0]?.leadsChat > data?.monthlyAccountSummaryStats[0]?.preLeadsChat ?
                                        <i className="fa fa-arrow-up wgreport-arrowUp"></i>
                                        : <i className="fa fa-arrow-down wgreport-arrowDown"></i>
                                    }
                                </span>
                                <span className="wgreport-MAS">{desktopmfchatContactAvg}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={firstRTIcon} />
                        </div>
                        <h6 className="wgreport_heading" >{t('DashboardReport-dataTable.FIRST-RESPTIME')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblAvgFirstResponse + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{firstResponseTime}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.Total')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.avgFirstResponse + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={avgRTIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.AVG-RESPTIME')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblAvgChatResponse + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{avgResponseTime}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.Total')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.avgChatResponse + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                    </div>
                    <div id="section2">
                        <div className="img-div">
                            <img className="wgreport-icon" src={avgChat} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.AVG-CHATDURATION')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.mblAvgChatDurationMint + "m" + data?.monthlyAccountSummaryStats[0]?.mblAvgChatDurationSec + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.MOBILE')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.overallChatDurationMint + "m" + data?.monthlyAccountSummaryStats[0]?.overallChatDurationSec + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.Total')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryStats[0]?.avgChatDurationMint + "m" + data?.monthlyAccountSummaryStats[0]?.avgChatDurationSec + "s"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.DESKTOP')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={sendingTime} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.AVG-CHATSENDING-TIME')}</h6>
                        <div className="row wgreport-row" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{avgsendingTime}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.OVERALL')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={performane} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.PERFOMANCE')}</h6>
                        <div className="row wgreport-row" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <div className="img-div">
                                    <img className="wgreport-icon" src={unhappyIcon} />
                                </div>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryThumbsUp[0].negativeFeedbacks == null ? 0 : data?.monthlyAccountSummaryThumbsUp[0].negativeFeedbacks}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.NEGATIVE-CLIENTFEEDBACK')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <div className="img-div">
                                    <img className="wgreport-icon" src={happyIcon} />
                                </div>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryThumbsUp[0].positiveClientFeedbacks == null ? 0 : data?.monthlyAccountSummaryThumbsUp[0].positiveClientFeedbacks}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.POSITIVE-CLIENTFEEDBACK')}</label>
                            </div>
                        </div>
                        <div className="row wgreport-row" style={{ display: "flex", justifyContent: "center" }}>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <div className="img-div">
                                    <img className="wgreport-icon" src={update} />
                                </div>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryThumbsUp[0].updates == null ? 0 : data?.monthlyAccountSummaryThumbsUp[0].updates}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.UPDATE-RECEIVED')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <div className="img-div">
                                    <img className="wgreport-icon" src={coverage} />
                                </div>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummaryThumbsUp[0].qcCoverage == null ? 0 : data?.monthlyAccountSummaryThumbsUp[0].qcCoverage}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.QUALITY-COVERAGE')}</label>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={systeminfoIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t('DashboardReport-dataTable.SYSTEM-INFORMATION')}</h6>
                        <div className="row wgreport-row">
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{"99%"}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.SERVICE-UPTIME')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummarySYSInfo[0]?.totalSeats}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.TEAM-STRENGTH')}</label>
                            </div>
                            <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                <span className="wgreport-MASspan">{data?.monthlyAccountSummarySYSInfo[0]?.autoGreetTime}</span>
                                <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.CHAT-POPUP-TIME')}</label>
                            </div>
                        </div>

                        {data?.monthlyAccountSummaryTopVehicals[0]?.showPage == true ?
                            <>   <Divider />
                                <div className="img-div">
                                    <img className="wgreport-icon" src={inquiredIcon} />
                                </div>
                                <h6 className="wgreport_heading">{t('DashboardReport-dataTable.MOST-INQUIRED-VEHICLE')}</h6>
                                <div className="row wgreport-row" style={{ display: "flex", justifyContent: "center" }}>
                                    <div className="card" style={{ width: "450px" }}>
                                        <DataTable value={data?.monthlyAccountSummaryTopVehicals}>
                                            <Column field="sr" header="SR"></Column>
                                            <Column field="vehicalModel" header="Vehicle Model"></Column>
                                        </DataTable>
                                    </div>
                                </div>
                                <div className="row wgreport-row">
                                    <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                        <div className="img-div">
                                            <img className="wgreport-icon" src={apptIcon} />
                                        </div>
                                        <span className="wgreport-MASspan">{data?.monthlyAccountSummaryChatDistributions[0]?.appointmentScheduled + data?.monthlyAccountSummaryChatDistributions[0]?.notScheduled}</span>
                                        <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.APPOINTMENTS-OFFERED')}</label>
                                    </div>
                                    <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                        <div className="img-div">
                                            <img className="wgreport-icon" src={apptIcon} />
                                        </div>
                                        <span className="wgreport-MASspan">{data?.monthlyAccountSummaryChatDistributions[0]?.appointmentScheduled}</span>
                                        <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.APPOINTMENTS-SCHEDULED')}</label>
                                    </div>
                                    <div className="col-md-3 col-lg-3 py-2 wgreport" style={{ textAlign: "center" }}>
                                        <div className="img-div">
                                            <img className="wgreport-icon" src={trandeinIcon} />
                                        </div>
                                        <span className="wgreport-MASspan">{data?.monthlyAccountSummaryChatDistributions[0]?.tradein}</span>
                                        <label className="wgreport-MASlabel">{t('DashboardReport-dataTable.TRADE-IN-INQURIES')}</label>
                                    </div>
                                </div>
                            </>
                            : ""
                        }
                        {data?.monthlyAccountSummaryCityCountry != null ? <>
                            <Divider />
                            <h6 className="wgreport_heading">{t('GraphReports-label.COUNTRY-WISE-DATA')}</h6>
                            <div className="row wgreport-row">
                                <div className="card">
                                    <HighchartsReact
                                        highcharts={Highcharts} options={basicData} />
                                </div>
                            </div>
                        </> : ""}
                        <Divider />
                    </div>
                    <div id="section3">
                        <div className="img-div">
                            <img className="wgreport-icon" src={distributionIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t('GraphReports-label.DEPARTMENT-WISE-CHATDISTRIBUTION')}</h6>
                        <div className="row wgreport-row">
                            <div className="card" style={{ width: "90%", background: "white" }}>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={ChatDistributions}
                                />
                                {!ChatDistributionData ? <h6 className="wgreport_heading" style={{ position: "relative", bottom: "50%" }}>{t('GraphReports-label.NoData-Display')}</h6> : ""}
                            </div>
                        </div>
                        <Divider />

                        <div className="img-div">
                            <img className="wgreport-icon" src={trafficTrendsIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t("DashboardReport-dataTable.TRAFFIC-TRENDS")}</h6>
                        <div className="row wgreport-row">
                            <div className="card" style={{ width: "90%", background: "white" }}>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={WeekOptions}
                                />
                                {!hasWeekData ? <h6 className="wgreport_heading" style={{ position: "relative", bottom: "50%" }}>{t('GraphReports-label.NoData-Display')}</h6> : ""}
                            </div>
                        </div>
                        <div className="row wgreport-row">
                            <div className="card" style={{ width: "90%", background: "white" }}>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={WeekendOptions}
                                />
                                {!hasWeekendData ? <h6 className="wgreport_heading" style={{ position: "relative", bottom: "50%" }}>{t('GraphReports-label.NoData-Display')}</h6> : ""}

                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={sourceIcon} />
                        </div>
                        <h6 className="wgreport_heading">{t("DashboardReport-dataTable.TOP-SOURCES")}</h6>
                        <div className="row wgreport-row">
                            <div className="card" style={{ width: "85%" }}>
                                {data?.monthlyAccountSummaryTopChatAndTraffic != null && data?.monthlyAccountSummaryTopChatAndTraffic != "" ? <>
                                    {newArray.length > 0 ?
                                        <HighchartsReact
                                            highcharts={Highcharts}
                                            options={Options1}
                                        />
                                        : <h6 className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>}
                                </>
                                    : <h6 className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>}
                            </div>
                        </div>
                        <Divider />
                    </div>
                    <div id="section4">
                        <div className="row wgreport-row">
                            <div className="card" style={{ width: "85%" }}>
                                {data?.monthlyAccountSummaryTopChatAndTraffic != null && data?.monthlyAccountSummaryTopChatAndTraffic != "" ?
                                    <>  {newArray2.length > 0 ? <HighchartsReact
                                        highcharts={Highcharts}
                                        options={Options2}
                                    />
                                        : <h6 className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>}
                                    </>
                                    : <h6 className="wgreport_heading">{t('GraphReports-label.NoData-Display')}</h6>}
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={chatLeadsIcon} />
                        </div>
                        <div className="row wgreport-row">
                            <div className="card" style={{ width: "90%" }}>
                                <h6 className="wgreport_heading">{t('GraphReports-label.CHATS-TO-LEADCOMPARISON')}</h6>
                                <HighchartsReact
                                    highcharts={Highcharts}
                                    options={ChatLead_Data1}
                                />
                            </div>
                        </div>
                        <Divider />
                        <div className="row wgreport-row">
                            <div className="card">
                                <img className="wgreport-noteImage" src={noteImage} />
                                <span className="wgreport-note">{t("StaticReport-Text.NOTES")}</span>
                                <div className="note-box">
                                    <span className="note-span">{t("StaticReport-Text.FirstNote")}
                                    </span><span className="note-span">
                                        {t("StaticReport-Text.SecondNote")}</span>
                                </div>
                            </div>
                        </div>
                        <Divider />
                        <div className="img-div">
                            <img className="wgreport-icon" src={chatLeadsIcon} />
                        </div>
                        <div className="card">
                            <h6 className="wgreport_heading">{t("StaticReport-Text.Glossary")}</h6>
                            <div className="glossary-box">
                                <ul style={{ textAlign: "left" }}>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b>{t("ChatTranscriptComponent.Visitor")}:</b>
                                        <span>{t("StaticReport-Text.visitor-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b>{t("ReportComponent.Chats")}:</b>
                                        <span>{t("StaticReport-Text.chat-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b>{t("DashboardReport-dataTable.Meaningful-Chats")}:</b>
                                        <span>{t("StaticReport-Text.MeaningfulChat-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b>{t("StaticReport-Text.MeaningfulChat-contacts")}:</b>
                                        <span>{t("StaticReport-Text.MeaningfulChat-contacts-text")} </span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b>{t("viewStatistics.First Response Time")}:</b>
                                        <span>{t("StaticReport-Text.frt-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b> {t("viewStatistics.Average Response Time")}:</b>
                                        <span>{t("StaticReport-Text.avg-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b> {t("StaticReport-Text.AverageChat-Duration")}:</b>
                                        <span>{t("StaticReport-Text.AverageChat-Duration-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b> {t("StaticReport-Text.AverageChat-SendingTime")}:</b>
                                        <span>{t("StaticReport-Text.AverageChat-SendingTime-text")}</span>
                                    </li>
                                    <li style={{ fontSize: "14px", margin: "5px" }}>
                                        <b> {t("StaticReport-Text.Engagement-Percentage")}:</b>
                                        <span>{t("StaticReport-Text.Engagement-Percentage-text")}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <Divider />
                    </div>
                </> : ""}
            </div>
        </div>
    )
}
export default MonthlyAccountSummary;